module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/kylie-cosmetics-2-81a2c67387b9cc36c5ba75882b4bbf67.png";